<template>
  <div id="app">
    <base-layout v-if="initSuccess">
      <router-view v-if="isReload" />
    </base-layout>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import BaseLayout from '@/layout/base-layout.vue'
import { getToken } from '@/utils/auth'

export default {
  name: 'App',
  components: {
    BaseLayout
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      initSuccess: true,
      isReload: true
    }
  },
  methods: {
    initApp() {
      //去加载凭证
      const token = getToken();
      if (token != null) {
        this.$store.commit('setToken', token);
      }
      //去加载会员信息
      // this.$store.dispatch('getUserProfile');
      this.initSuccess = true;
    },
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    },
    clickIncident(event) {
      if (event.srcElement.className == 'Confirm' || event.srcElement.className == "Register" || event.srcElement.className == "content_five3" || event.srcElement.className == "wallet") {
        if (window.ethereum == undefined) {
          Message.error(this.$t('PleaseInstallWallet'))
        }
      }
    },
    setRootFontSize() {
      const docEl = document.documentElement;
      const width = docEl.clientWidth;
      
      if (width > 768) {
        // PC端：1rem = 1px（禁用缩放）
        docEl.style.fontSize = '0.6px'; 
      } else {
        // 移动端：按设计稿比例计算（假设设计稿750px）
        const baseSize = 0.5; // 1rem = 100px (750设计稿)
        docEl.style.fontSize = `${baseSize}px`;
      }
    }
  },
  mounted() {
    window.addEventListener('mousedown', this.clickIncident);
    this.initApp();
    // 初始化执行
    this.setRootFontSize();
    // 监听窗口变化
    window.addEventListener('resize', this.setRootFontSize);
  },
}
</script>

<style lang="less">
#app {
  min-height: 100vh;
  // background: #1A1A0F;
}

@media screen and (min-width: 480px) {
  #app {
    height: 853px;
    overflow: auto;
  }

  body {
    width: 480px;
    height: 853px;
    transform: perspective(0);
    margin: auto !important;
    overflow: auto;
  }
}
::-webkit-scrollbar {
  display: none; /* Chrome/Safari 隐藏滚动条 */
}
</style>
